import React from "react";
import Modalpopup from "./Modalpopup";
import DefaultButton from "./DefaultButton";

const ConfirmModal = ({ show, handleClose, handleConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel" }) => {
    return (
        <Modalpopup
            show={show}
            handleClose={handleClose}
            actionTitle={title || "Confirm"}
        >
            <p>{message}</p>

            <DefaultButton
                buttonClass={'btn-secondary me-2'}
                buttonTitle={cancelText}
                actionBlock={handleClose}
            />
            <DefaultButton
                buttonClass={'btn-primary default-btn-color'}
                buttonTitle={confirmText}
                actionBlock={handleConfirm}
            />
        </Modalpopup>
    );
};

export default ConfirmModal;
